// @flow
import { ActivitiesActionTypes } from './constants';

const INIT_STATE = {
    activity: {},
    listaActivities: [],
    loading: false,
    error: false,
    formSubmited: false
};

type ActivitiesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { activity?: {} | null, listaActivities?: [] | null, loading?: boolean, +value ?: boolean };

const Activities = (state: State = INIT_STATE, action: ActivitiesAction): any => {
    // console.log(action);
    switch (action.type) {
        case ActivitiesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ActivitiesActionTypes.GET_ACTIVITY: {
                    return {
                        ...state,
                        activity: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ActivitiesActionTypes.LIST_ACTIVITIES: {
                    return {
                        ...state,
                        listaActivities: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ActivitiesActionTypes.ADD_ACTIVITY:
                case ActivitiesActionTypes.UPDATE_ACTIVITY:
                case ActivitiesActionTypes.DELETE_ACTIVITY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }

                default:
                    return { ...state };
            }

        case ActivitiesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ActivitiesActionTypes.GET_ACTIVITY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        activity: {},
                        loading: false,
                    };
                }
                case ActivitiesActionTypes.LIST_ACTIVITIES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaActivities: [],
                        loading: false,
                    };
                }
                case ActivitiesActionTypes.ADD_ACTIVITY:
                case ActivitiesActionTypes.UPDATE_ACTIVITY:
                case ActivitiesActionTypes.DELETE_ACTIVITY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ActivitiesActionTypes.GET_ACTIVITY:
            return { ...state, error: false, loading: true };
        case ActivitiesActionTypes.LIST_ACTIVITIES:
            return { ...state, error: false, loading: true };
        case ActivitiesActionTypes.ADD_ACTIVITY:
            return { ...state, error: false, loading: true };
        case ActivitiesActionTypes.UPDATE_ACTIVITY:
            return { ...state, error: false, loading: true };
        case ActivitiesActionTypes.DELETE_ACTIVITY:
            return { ...state, error: false, loading: true };
        case ActivitiesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                activity: {},
                listaActivities: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Activities;
